import React, { useState, useEffect } from "react";
import { Button, Modal, List, Row, Col, Tag } from "antd";
import {
  MailOutlined,
  CheckCircleOutlined,
  InboxOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  FileProtectOutlined,
  CheckOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import DateCustom from "../../../../hook/DateCustom";

const DataCheck = ({ open, close, data, status }) => {
  const [dataArr, setDataArr] = useState([]);
  const [convertDateThai, convertDateThaiShort] = DateCustom();

  useEffect(() => {
    if (data) {
      loadData();
    }
    console.log("dataFailed1111", data);
    console.log("status", status);
  }, [data, status]);

  const loadData = () => {
    let selectedArray = [];

    if (status === "all") {
      selectedArray = data.all || [];
    } else if (status === "waitLawsuit") {
      selectedArray = data.waitLawsuit || [];
    } else if (status === "withBackCase") {
      selectedArray = data.withBackCase || [];
    } else if (status === "withRedCase") {
      selectedArray = data.withRedCase || [];
    } else if (status === "ageeement") {
      selectedArray = data.ageeement || [];
    } else if (status === "finish") {
      selectedArray = data.finish || [];
    } else if (status === "withdrawCase") {
      selectedArray = data.withdrawCase || [];
    }

    setDataArr(selectedArray);
  };

  const handleCancel = () => {
    close(false);
  };

  const tagStyle = {
    fontSize: "16px",
    padding: "10px 16px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontWeight: "bold",
  };

  // ✅ ฟังก์ชันแสดง Tag ตามสถานะ
  const renderStatusTag = () => {
    const tagConfig = {
      all: {
        color: "#3357FF",
        textColor: "#fff",
        icon: <InboxOutlined />,
        label: "ทั้งหมด",
      },
      waitLawsuit: {
        color: "#FFD699",
        textColor: "#000",
        icon: <ClockCircleOutlined />,
        label: "รอฟ้อง",
      },
      withBackCase: {
        color: "#FFB84D",
        textColor: "#000",
        icon: <CalendarOutlined />,
        label: "มีวันนัดศาล",
      },
      withRedCase: {
        color: "#4DFF88",
        textColor: "#000",
        icon: <CheckCircleOutlined />,
        label: "พิพากษาแล้ว",
      },
      ageeement: {
        color: "#87D068",
        textColor: "#fff",
        icon: <FileProtectOutlined />,
        label: "ยอมความ",
      },
      finish: {
        color: "#52C41A",
        textColor: "#fff",
        icon: <CheckOutlined />,
        label: "จบคดี",
      },
      withdrawCase: {
        color: "#FF4D4F",
        textColor: "#fff",
        icon: <CloseCircleOutlined />,
        label: "ถอนคดี",
      },
    };

    const config = tagConfig[status] || tagConfig.all;

    return (
      <Tag
        color={config.color}
        style={{ ...tagStyle, color: config.textColor }}
      >
        {config.icon} {config.label}: {dataArr.length} สัญญา
      </Tag>
    );
  };

  return (
    <>
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <MailOutlined style={{ color: "#1890ff" }} />
            รายละเอียดข้อมูล
          </div>
        }
        open={open}
        width={900}
        onCancel={handleCancel}
        footer={[
          <Button key="close" danger onClick={handleCancel}>
            ปิด
          </Button>,
        ]}
      >
        <Row>
          <Col span={24} style={{ padding: "5px" }}>
            <List
              size="small"
              header={
                <>
                  {/* ✅ แสดง Tag สถานะ */}
                  <div
                    style={{
                      textAlign: "center",
                      marginBottom: "12px",
                    }}
                  >
                    {renderStatusTag()}
                  </div>

                  {/* ✅ หัวตาราง */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 2fr 1fr",
                      fontWeight: "bold",
                      padding: "10px 16px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      gap: "10px",
                    }}
                  >
                    <span>เลขสัญญา</span>
                    <span>ชื่อลูกค้า</span>
                    <span style={{ textAlign: "center" }}>วันที่นำเข้า</span>
                  </div>
                </>
              }
              bordered
              dataSource={dataArr}
              renderItem={(item, index) => (
                <List.Item
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 2fr 1fr",
                    padding: "12px 16px",
                    gap: "10px",
                    backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                    transition: "all 0.2s",
                  }}
                  className="hover-row"
                >
                  <span style={{ fontWeight: 500, color: "#1890ff" }}>
                    {item.CONTNO || "-"}
                  </span>
                  <span style={{ color: "#262626" }}>
                    {item.CUSTOMER_TNAME || ""}
                    {item.CUSTOMER_FNAME || ""} {item.CUSTOMER_LNAME || ""}
                  </span>
                  <span style={{ textAlign: "center", color: "#595959" }}>
                    {item.DATE ? convertDateThaiShort(item.DATE) : "-"}
                  </span>
                </List.Item>
              )}
              locale={{
                emptyText: (
                  <div style={{ padding: "40px", color: "#bfbfbf" }}>
                    <InboxOutlined style={{ fontSize: 48 }} />
                    <div style={{ marginTop: 8 }}>ไม่มีข้อมูล</div>
                  </div>
                ),
              }}
            />
          </Col>
        </Row>

        {/* ✅ เพิ่ม CSS สำหรับ hover effect */}
        <style jsx>{`
          .hover-row:hover {
            background-color: #e6f7ff !important;
            cursor: pointer;
          }
        `}</style>
      </Modal>
    </>
  );
};

export default DataCheck;
